var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef, Icon, Input as OriginInput, InputGroup, InputLeftElement, InputRightElement, Spinner, Text, Textarea, } from '@chakra-ui/react';
import { isValidElement, useCallback } from 'react';
export const InputElementContent = ({ content }) => {
    if (typeof content === 'string') {
        return (_jsx(Text, Object.assign({ color: "inherit", width: "100%", fontWeight: "bold" }, { children: content })));
    }
    else if (isValidElement(content)) {
        return content;
    }
    else if (typeof content === 'function') {
        return _jsx(Icon, { as: content, verticalAlign: "middle" });
    }
    return null;
};
export const Input = forwardRef((_a, ref) => {
    var { value = '', isLoading = false, prefix, suffix, onChange } = _a, props = __rest(_a, ["value", "isLoading", "prefix", "suffix", "onChange"]);
    const onInputChange = useCallback((evt) => {
        evt.preventDefault();
        evt.stopPropagation();
        onChange === null || onChange === void 0 ? void 0 : onChange(evt);
    }, [onChange]);
    const { w, width, h, height, size } = props, extraProps = __rest(props, ["w", "width", "h", "height", "size"]);
    return (_jsxs(InputGroup, Object.assign({ width: w || width, height: h || height, size: size }, { children: [prefix && (_jsx(InputLeftElement, Object.assign({ fontSize: size, color: "gray.400", pointerEvents: "none" }, { children: _jsx(InputElementContent, { content: prefix }) }))), _jsx(OriginInput, Object.assign({ ref: ref, value: value, onChange: onInputChange }, extraProps)), ";", (suffix || isLoading) && (_jsx(InputRightElement, Object.assign({ fontSize: size, color: "gray.400", pointerEvents: "none" }, { children: isLoading ? _jsx(Spinner, { size: props.size, color: "gray.200" }) : _jsx(InputElementContent, { content: suffix }) })))] })));
});
export { Textarea };
export default Input;
